import { VisStatusMessage } from './VisStatusMessage';
import { useTranslationBundle } from '../hooks/UNSAFE_useTranslationBundle';
import { BundleType } from '../resources/nls/bundle';
import { HTMLAttributesSignalExcluded } from '../utils/UNSAFE_attributeUtils';
import { getRandomId } from '../utils/PRIVATE_visLayoutUtils/layoutUtils';

type Props = {
  'aria-label'?: HTMLAttributesSignalExcluded['aria-label'];
  'aria-describedby'?: HTMLAttributesSignalExcluded['aria-describedby'];
  'aria-labelledby'?: HTMLAttributesSignalExcluded['aria-labelledby'];
};

export function VisNoData(props: Props) {
  const translations = useTranslationBundle<BundleType>('@oracle/oraclejet-preact');
  const noDataMsg = translations.vis_noData();
  const textId = getRandomId();
  const { ariaLabelledBy, id } = getAriaLabelledBy({
    ariaLabel: props['aria-label'],
    ariaLabelledby: props['aria-labelledby'],
    textId
  });
  return (
    <VisStatusMessage
      id={id}
      aria-label={props['aria-label']}
      aria-describedby={props['aria-describedby']}
      aria-labelledby={ariaLabelledBy}>
      <span id={textId}>{noDataMsg}</span>
    </VisStatusMessage>
  );
}

const getAriaLabelledBy = (props: {
  ariaLabel?: string;
  ariaLabelledby?: string;
  textId: string;
}): { ariaLabelledBy: string; id?: string } => {
  const id = props.ariaLabel ? getRandomId() : undefined;
  const ariaLabelledBy = `${props.ariaLabelledby ?? ''} ${id ?? ''} ${props.textId}`.trim();
  return { ariaLabelledBy, id };
};
